import { useEffect, useState } from "react";
import { publicApi } from "@/lib/api";

const FALLBACK = { count: 3, auto: false, seconds: 4 };
let cache = null;

export const loadDisplay = (fresh = false) => {
  if (!cache || fresh) cache = publicApi.get("/public/display-settings").then((r) => r.data).catch(() => ({}));
  return cache;
};

export const useDisplay = (section) => {
  const [s, setS] = useState(null);
  useEffect(() => {
    let live = true;
    loadDisplay().then((d) => { if (live) setS(d[section] || FALLBACK); });
    return () => { live = false; };
  }, [section]);
  return s;
};

export const useDevotionalsOn = () => {
  const [on, setOn] = useState(true);
  useEffect(() => {
    let live = true;
    loadDisplay().then((d) => { if (live) setOn(d.devotionals_enabled !== false); });
    return () => { live = false; };
  }, []);
  return on;
};

export const keepLink = (on) => (x) => on || x.href !== "/devotionals";
